import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "wrapped", "wrapperStyles"];
import React from 'react';
import PropTypes from 'prop-types';
import CardContent from './CardContent';
import CardWrapper from './CardWrapper';
export function Card(_ref) {
  var children = _ref.children,
    wrapped = _ref.wrapped,
    wrapperStyles = _ref.wrapperStyles,
    props = _objectWithoutProperties(_ref, _excluded);
  var card = /*#__PURE__*/React.createElement(CardContent, props, children);
  return wrapped ? /*#__PURE__*/React.createElement(CardWrapper, {
    customStyles: wrapperStyles
  }, card) : card;
}
Card.propTypes = {
  children: PropTypes.node.isRequired,
  customStyles: PropTypes.object,
  wrapperStyles: PropTypes.object,
  wrapped: PropTypes.bool
};
Card.defaultProps = {
  wrapped: false,
  customStyles: null,
  wrapperStyles: null
};
export default Card;